import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';

import { DisputeMediationClient } from '@/components/admin/dispute-mediation-client';
import { PageHeader } from '@/components/dashboard/page-header';

export const Route = createFileRoute('/_admin/admin/disputes_/$disputeId')({
  component: AdminDisputeMediationPage,
});

function AdminDisputeMediationPage(): React.ReactElement {
  const { disputeId } = Route.useParams();
  return (
    <div className="mx-auto flex w-full max-w-[100rem] flex-col gap-6">
      <PageHeader
        title="Médiation du litige"
        subtitle="Dossier complet : devis, attentes, historique de tâche, livrables et échanges."
      />
      <DisputeMediationClient disputeId={disputeId} />
    </div>
  );
}
